// extracted by mini-css-extract-plugin
export var addressFields = "_od-0";
export var animationContainer = "_od-1";
export var footer = "_od-2";
export var lineItems = "_od-3";
export var modalContent = "_od-4";
export var orderName = "_od-5";
export var strong = "_od-6";
export var warning = "_od-7";